// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2QRMc","content":"styles_content__3NuNw","checkbox":"styles_checkbox__VRSuo","checkboxLabel":"styles_checkboxLabel__Qs-B5"};